module.exports = __webpack_public_path__ + "static/img/nr.e6357f8e.svg";